import { Button, Paper, useTheme } from '@material-ui/core'
import React from 'react'
import { Container } from '../../components'
import { EndOfTurnReport, ListVendor, ModelListMap } from '../../models'
import { typographyStyle } from '../../theme/typographyStyle'
import { ArchivedScheduleVendorCard } from './ArchivedScheduleVendorCard'

interface Props {
    vendorList: ListVendor[]
    endOfTurnReportList: EndOfTurnReport[]
    analyticsUnlocked: boolean
    onClickRateVendors: () => void
}

export const ArchivedScheduleBody = (props: Props) => {
    const {
        vendorList,
        endOfTurnReportList,
        analyticsUnlocked,
        onClickRateVendors,
    } = props
    const theme = useTheme()

    const endOfTurnReportMap: ModelListMap<EndOfTurnReport> = {}

    vendorList.forEach((vendor) => (endOfTurnReportMap[vendor.id] = []))
    endOfTurnReportList.forEach((eotReport) =>
        endOfTurnReportMap[eotReport.vendor.id]?.push(eotReport),
    )

    return (
        <Container style={{ flex: 1 }} scrollY>
            <Paper
                style={{
                    boxShadow: theme.shadows[2],
                    margin: theme.spacing(1),
                    flex: 1,
                }}
            >
                {vendorList.length > 0 && !analyticsUnlocked ? (
                    <Container
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                        style={{
                            flex: 1,
                            minHeight: 320,
                            padding: theme.spacing(4),
                            gap: theme.spacing(2),
                        }}
                    >
                        <span
                            style={{
                                ...typographyStyle(theme.typography.subtitle1),
                                fontWeight: 700,
                                textAlign: 'center',
                            }}
                        >
                            Please rate your vendors to see analytics
                        </span>
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={onClickRateVendors}
                        >
                            Rate vendors
                        </Button>
                    </Container>
                ) : (
                    <Container
                        style={{
                            borderRadius: `${theme.shape.borderRadius} 0 0 ${theme.shape.borderRadius}`,
                            backgroundColor: theme.palette.grey[200],
                            boxShadow: `3px 0px 3px -1px ${theme.palette.grey[500]}`,
                            flexWrap: 'wrap',
                            flexDirection: 'row',
                            flex: 1,
                        }}
                    >
                        {vendorList.map((ven, idx) => {
                            return (
                                <ArchivedScheduleVendorCard
                                    key={`VENDOR_RATING_COMPONENT_${ven.id}_${idx}`}
                                    vendor={ven}
                                    reports={endOfTurnReportMap[ven.id]!}
                                />
                            )
                        })}
                    </Container>
                )}
            </Paper>
        </Container>
    )
}
